import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import "rxjs/add/operator/map";
import { environment } from "../../../../environments/environment";
import { QubesUser, QubesEnvironmentAccess } from "./model/qubes-user";
import { Menu } from "./model/menu";
import { QubesUserGroup, QubesUserGroupMaster } from "./model/qubes-user-group";
import { QubesUserRole } from "./model/qubes-user-role";
import { QubesUserGroupRoleMapping } from "./model/qubes-user-group-role-mapping";
import { QubesUserGroupMenuMapping } from "./model/qubes-user-group-menu-mapping";
import { Observable } from "rxjs/Observable";

@Injectable({ providedIn: "root" })
export class QubesUserManagementService {
  serviceApiUrl: string = environment.serviceApiUrl;
  hideSideNav:boolean = false

  constructor(private http: HttpClient) {}

  toggleSideNav(): void {
    this.hideSideNav = !this.hideSideNav;

    console.log("menu checking",this.hideSideNav);
  }

  getAllUserData() {
    return this.http.get<Array<QubesUser>>(
      this.serviceApiUrl + "qubes-user/all"
    );
  }

  getAllUserDataQms() {
    return this.http.get<Array<QubesUser>>(
      this.serviceApiUrl + "qubes-user/qms"
    );
  }

  getAllUserDataMoh() {
    return this.http.get<Array<QubesUser>>(
      this.serviceApiUrl + "qubes-user/moh"
    );
  }

  getUserById(id) {
    return this.http.get<QubesUser>(this.serviceApiUrl + "qubes-user/" + id);
  }

  getEnvironmentAccessByUserId(userId) {
    return this.http.get<QubesEnvironmentAccess>(
      this.serviceApiUrl + "qubes-user/environment-access/" + userId
    );
  }

  addUser(user) {
    return this.http.post(this.serviceApiUrl + "qubes-user/add", user);
  }

  updateUser(user) {
    return this.http.put(this.serviceApiUrl + "qubes-user/update", user);
  }
  deleteUser(user) {
    return this.http.put(
      this.serviceApiUrl + "qubes-user/delete/" + user.id,
      user
    );
  }

  getAllUserGroupData() {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl + "qubes-user-group/all"
    );
  }
  checkUserGroupPriority(masterPriorityId: number, qroupPriorityId: number) {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl +
        "qubes-user-group/user-group-priority?master-priority-id=" +
        masterPriorityId +
        "&group-priority-id=" +
        qroupPriorityId
    );
  }
  addUserGroup(userGroup) {
    return this.http.post(
      this.serviceApiUrl + "qubes-user-group/add",
      userGroup
    );
  }

  updateUserGroup(userGroup) {
    return this.http.put(
      this.serviceApiUrl + "qubes-user-group/update",
      userGroup
    );
  }

  updateUserGroupPriority(userGroupList) {
    return this.http.put(
      this.serviceApiUrl + "qubes-user-group/update-priority",
      userGroupList
    );
  }

  deleteUserGroup(userGroup) {
    //
    return this.http.delete(
      this.serviceApiUrl + "qubes-user-group/delete/" + userGroup.id
    );
  }
  getUserGroupDataByMasterId(id) {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl + "qubes-user-group/user-group-master/" + id
    );
  }

  getAllUserGroupMasterData() {
    return this.http.get<Array<QubesUserGroupMaster>>(
      this.serviceApiUrl + "qubes-user-group-master/all"
    );
  }
  addUserGroupMaster(userGroupMaster) {
    return this.http.post(
      this.serviceApiUrl + "qubes-user-group-master/add",
      userGroupMaster
    );
  }

  updateUserGroupMaster(userGroupMaster) {
    return this.http.put(
      this.serviceApiUrl + "qubes-user-group-master/update",
      userGroupMaster
    );
  }

  deleteUserGroupMaster(userGroupMaster) {
    //
    return this.http.delete(
      this.serviceApiUrl +
        "qubes-user-group-master/delete/" +
        userGroupMaster.id
    );
  }

  getAllUserRoleData() {
    return this.http.get<Array<QubesUserRole>>(
      this.serviceApiUrl + "qubes-user-role/all"
    );
  }
  addUserRole(userRole) {
    return this.http.post(this.serviceApiUrl + "qubes-user-role/add", userRole);
  }

  updateUserRole(userRole) {
    return this.http.put(
      this.serviceApiUrl + "qubes-user-role/update",
      userRole
    );
  }

  deleteUserRole(userRole) {
    return this.http.delete(
      this.serviceApiUrl + "qubes-user-role/delete/" + userRole.id
    );
  }

  getUserGroupRoleMappingByGroupId(id) {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl + "qubes-user-group-role-mapping/group-id/" + id
    );
  }
  getUserGroupRoleMappingByRoleId(id) {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl + "qubes-user-group-role-mapping/role-id/" + id
    );
  }

  getUserDetailByGroupId(id) {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl + "qubes-user-detail/group-id/" + id
    );
  }

  getAllUserGroupRoleMappingData() {
    return this.http.get<Array<QubesUserGroupRoleMapping>>(
      this.serviceApiUrl + "qubes-user-group-role-mapping/all"
    );
  }
  addUserGroupRoleMapping(userGroupRoleMapping) {
    return this.http.post(
      this.serviceApiUrl + "qubes-user-group-role-mapping/add",
      userGroupRoleMapping
    );
  }

  updateUserGroupRoleMapping(userGroupRoleMapping) {
    return this.http.put(
      this.serviceApiUrl + "qubes-user-group-role-mapping/update",
      userGroupRoleMapping
    );
  }

  deleteUserGroupRoleMapping(userGroupRoleMapping) {
    return this.http.delete(
      this.serviceApiUrl +
        "qubes-user-group-role-mapping/delete/" +
        userGroupRoleMapping.id
    );
  }
  getAllMenuData() {
    return this.http.get<Array<Menu>>(this.serviceApiUrl + "qubes-menu/all");
  }
  getAllUserGroupMenuMappingData() {
    return this.http.get<Array<QubesUserGroupMenuMapping>>(
      this.serviceApiUrl + "qubes-user-group-menu-mapping/all"
    );
  }
  getAllUserGroupMenuMappingByGroupId(id) {
    return this.http.get<Array<QubesUserGroupMenuMapping>>(
      this.serviceApiUrl + "qubes-user-group-menu-mapping/group-id/" + id
    );
  }
  addUserGroupMenuMapping(userGroupRoleMappingList) {
    return this.http.post(
      this.serviceApiUrl + "qubes-user-group-menu-mapping/add",
      userGroupRoleMappingList
    );
  }
  deleteUserGroupMenuMapping(userGroupRoleMappingList) {
    return this.http.put(
      this.serviceApiUrl + "qubes-user-group-menu-mapping/delete",
      userGroupRoleMappingList
    );
  }
  public fetchAllClinicCategory() {
    return this.http.get<Array<any>>(this.serviceApiUrl + "clinicCategory/all");
  }
  public fetchAllState() {
    return this.http.get<Array<any>>(this.serviceApiUrl + "state/all");
  }

  public fetchAllDistrict() {
    return this.http.get<Array<any>>(this.serviceApiUrl + "district/all");
  }

  public fetchAllCircleByStateId(stateId: number) {
    return this.http.get<Array<any>>(
      this.serviceApiUrl + "circle/state-id/" + stateId
    );
  }

  public fetchAllDistrictByStateId(stateId: number) {
    return this.http.get<Array<any>>(
      this.serviceApiUrl + "district/state-id/" + stateId
    );
  }

  public fetchAllClinic() {
    return this.http.get<Array<any>>(this.serviceApiUrl + "clinic/all");
  }

  public fetchAllClinicByDistrictId(districtId: number) {
    return this.http.get<Array<any>>(
      this.serviceApiUrl + "clinic/district-id/" + districtId
    );
  }

  deleteUserDetail(userDetail) {
    return this.http.delete(
      this.serviceApiUrl + "qubes-user/delete-user-detail/" + userDetail.id
    );
  }
  getUserByEmailId(emailId) {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl + "qubes-user/email/" + emailId
    );
  }
  approveDeviceMapping(id, deviceStatus) {
    return this.http.get<Array<QubesUserGroup>>(
      this.serviceApiUrl +
        "deviceMapping/approve?id=" +
        id +
        "&status=" +
        deviceStatus
    );
  }
  fetchAllDeviceMapping(stateId,circleId,districtId,status) {
    let urlString = "deviceMapping/all?" 
    if (stateId != null && stateId != '' && stateId != undefined) {
      urlString += "stateId=" + stateId
    }
    if (circleId != null && circleId != '' && circleId != undefined) {
      urlString += "&circleId=" + circleId
    }
   
    if (districtId != null && districtId != '' && districtId != undefined) {
      urlString += "&districtId=" + districtId
    }

    if (status != null && status != '' && status != undefined) {
      urlString += "&status=" + status
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + urlString);
   
  }
  deviceMappingDeRegister(id) {
    return this.http.delete<Observable<any>>(
      this.serviceApiUrl + "deviceMapping/deRegister?id=" + id
    );
  }
  fetchAllUserLoginDetails(){
   return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user-login/all")
  }
  fetchAlluserLoginDetailGrouped(){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user-login/fetchAllGrouped")
  }
  fetchAllLoggedHours(page,size,sortBy,sortDirection,searchValue){
    let data = ""
    if (page != null && page != "") {
      data += "page=" + page + "&"
    }
    if (size != null && size != "") {
      data += "size=" + size + "&"
    }
    if (sortBy != null && sortBy != "") {
      data += "sortBy=" + sortBy + "&"
    }
    if (sortDirection != null && sortDirection != "") {
      data += "sortDirection=" + sortDirection + "&"
    }
    if (searchValue != null && searchValue != "") {
      data += "searchValue=" + searchValue + "&"
    }

    return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user-login/fetchAllGroupedNew?" + data) ;

    // return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user-login/fetchAllGroupedNew")

  }

  fetchuserLoginDetailByName(userName){
    return this.http.get<Observable<any>>(this.serviceApiUrl + "qubes-user-login/findByUserName?userName=" + userName)
  }
}
